import React from 'react';

const MongoDB_Syllabus = () => {
  return (
    <div>
      <h1>MongoDB_Syllabus Component</h1>
      <p>This is the MongoDB_Syllabus page.</p>
    </div>
  );
};

export default MongoDB_Syllabus;
